export default __webpack_public_path__ + "static/media/m27.9b4d7c77.jpg";